import React, {useEffect, useState} from "react";
import Subscription from "../libs/Subscription";
import SubscriptionDetail from "./SubscriptionDetail";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import CustomSpinner from "../../components/CustomSpinner";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {getSubscriptions} from "../../store/actions/subscriptions";
import {selectActiveCompanyId, selectUser} from "../../store/reducers/userCompany";
import {startLoading, stopLoading} from "../../store/actions/loading";
import AlertDismissible from "../../components/old/AlertDismissible";

export default function ChangeSubscription() {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [message, setMessage] = useState({});
  const [activeSubscription, setActiveSubscription] = useState(null);
  const [subscriptionModel, setSubscriptionModel] = useState(false);
  const [modal, setModal] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const subscriptions = useSelector((state) => state.subscriptions.subscriptions.subscriptions) || [];
  const user = useSelector(selectUser) || {};
  const resellerActiveSubscription = useSelector( (state) => state?.reseller?.reseller.user?.companies[0]?.subscription?.subscription_id);
  const handleClose = () => {
    setModal(false);
    setMessage({});
  };
  const handelShow = () => setModal(true);
  let companyId = useSelector(selectActiveCompanyId);
  const userCompanyId = useSelector((state) => state?.reseller?.reseller.user?.companies[0]?.id)
  const isLoggedIn = localStorage.getItem("token") !== null;

  const handleSubscriptionClick = (subscription) => {
    setSubscriptionModel((prev) => !prev);
    setSelectedSubscription(subscription);
    handelShow();
  };

  const handlePayment = () => {
    setIsLoading(true);
    dispatch(startLoading());// show loading
    if (user?.userType === "reseller") {
      companyId = userCompanyId
    }
    Subscription.makePayment(selectedSubscription.id, companyId)
        .then((res) => {
          dispatch(stopLoading());
          window.location.href = res.checkout_url;
        }).catch(error => {
      setMessage({
        message: error.response.data.message,
        variant: "danger"
      });
      console.log(error);
      dispatch(stopLoading());
      setIsLoading(false);
    });
  }

  useEffect(() => {
    if (user?.userType !== "reseller") fetchData();
    dispatch(getSubscriptions());
    // eslint-disable-next-line
  }, []);

  let fetchData = async () => {
    try {
      const activeSub = Subscription.getCompanyActiveSubscription();
      if (activeSub) {
        activeSub.then(async (res) => {
          await setActiveSubscription(res.companySubscription.subscription_id);
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <h4 className="my-4">{t("Change Subscription")}</h4>

      {subscriptions.length ? (
        <div className={`mt-4 ${isLoggedIn ? "row" : "row justify-content-evenly"}`}>
          {subscriptions &&
            subscriptions.map((subscription, index) => {
              return (
                <SubscriptionDetail
                  title={activeSubscription === subscription.id ||
                  resellerActiveSubscription === subscription.id && user?.userType === "reseller" ? t("Current Plan") : "Plan"} key={index}
                  subscription={subscription} handleSubscriptionClick={() => {
                  handleSubscriptionClick(subscription)
                }}
                  className={
                    (activeSubscription === subscription.id ||
                    resellerActiveSubscription === subscription.id && user?.userType === "reseller" ? "active-border" : "")
                  }
                />
              );
            })}
        </div>
      ) : (
        <CustomSpinner/>
      )}

      {subscriptionModel && (
        <Modal centered show={modal} onHide={handleClose} animation={false}>
          {message.message && <AlertDismissible textMessage={message.message} variant={message.variant}/>}
          <Modal.Header closeButton>
            <Modal.Title>{t("Change Subscription")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>{t("Are you sure you want to change subscription")}?</h6>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handlePayment} disabled={isLoading}>
            {t("Save")}
            </Button>
            <Button variant="danger" onClick={handleClose}>
              {t("Cancel")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}
